//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import searchInput from '@/components/search-input';
import fileUpload from '@/components/file-upload';


export default {
  name: "cargo-query-rows",
  components: {DivSpan,searchInput,fileUpload},
  data() {
    return {
      list: [],
      searchData: {},
      page: 0,
      show: true,
      showMore: true,
      codeSort: 'createdDate,DESC'
    }
  },

  methods: {
    delMatName(){
      delete this.searchData['purOrderDetail.materialName']
      this.getList()
    },
    searchMatName(value) {
      this.searchData['purOrderDetail.materialName']=value;
      this.getList()
    },
    delOrderNumber(){
      delete this.searchData['purOrderDetail.purOrder.orderNo']
      this.getList()
    },
    searchOrderNumber(value) {
      this.searchData['purOrderDetail.purOrder.orderNo']=value;
      this.getList()
    },
    delOrderLine(){
      delete this.searchData['purOrderDetail.itemNo']
      this.getList()
    },
    searchOrderLine(value) {
      this.searchData['purOrderDetail.itemNo']=value;
      this.getList()
    },
    view(id){
      this.$router.push('/cargo-view/'+id)
    },
    //获取列表
    getList() {
      this.show=false
      this.$loadingShow();
      this.$search('api/requireGoodsPlanRow', {sort:this.codeSort,page: 0, size: 10}, this.searchData).then((data) => {
        this.list = data;
        this.show=true
        data.length<10?this.showMore=false:''
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
        this.show=true
      });
    },
    getMore(){
      this.page++;
      this.$loadingShow()
      this.show=false;
      this.$search('api/requireGoodsPlanRow', {sort:this.codeSort, page: this.page, size: 10},this.searchData).then(list => {
        this.list = this.list.concat(list);
        this.show=true;
        this.$loadingHide()
        list.length<10?(this.showMore=false):''
      }).catch((error) => {
        this.show=true;
        this.$loadingHide()
      });
    },
    // 跳转到 常用页面
    goGeneral() {
      if(this.$store.state.device === 'wap'){
        this.$router.go(-1);
      }else{
        document.location = "http://action:10002/?";
      }
    },
  },
  mounted() {
    this.getList();
  },


}



// WEBPACK FOOTER //
// ./src/page/cargo-plan/cargo-query-rows.vue